const emailRegex = /(.+)@(.+)\.(.+)/

const validateEmail = (email) => emailRegex.test(email)
const validateDummy = (value) => true

export default {
    validateEmail, validateDummy
}



// WEBPACK FOOTER //
// ./lib/Validation.js